module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-02.87572b6d8a81ba3082055f95e5421d39.png";